import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Observable, throwError } from "rxjs";
import { HostUrlService } from "../host-url.service";
import {
  NbAuthJWTToken,
  NbAuthService,
  NbAuthSimpleToken,
} from "@nebular/auth";
import { Router } from "@angular/router";
import { User } from "../../models/user.model";
import { catchError, map } from "rxjs/operators";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable({
  providedIn: "root",
})
export class AuthService {
  endpoint: string = "http://98.82.170.37:3000/auth";
  headers = new HttpHeaders().set("Content-Type", "application/json");
  currentUser = {};
  user: any;

  constructor(
    private http: HttpClient,
    public router: Router,
    private authService: NbAuthService
  ) { }
  getCurrentUser() {
    this.authService.onTokenChange().subscribe((token: NbAuthJWTToken) => {
      //console.log("header", token);
      if (token.isValid()) {
        this.user = token.getPayload(); // here we receive a payload from the token and assigns it to our `user` variable
        return this.user;
      }
    });
  }

  // Sign-up
  register(user: User): Observable<any> {
    let api = `${this.endpoint}/register`;
    return this.http.post(api, user).pipe(catchError(this.handleError));
  }

  // Sign-in
  /* signIn(user: User) {
    return this.http
      .post<any>(`${this.endpoint}/login`, user)
      .subscribe((res: any) => {
        localStorage.setItem("access_token", res.token);
        this.router.navigate(["pages/dashboard"]);
      });
  } */

  getToken() {
    return localStorage.getItem("access_token");
  }
  get isLoggedIn(): boolean {
    let authToken = localStorage.getItem("access_token");
    return authToken !== null ? true : false;
  }
  doLogout() {
    let removeToken = localStorage.removeItem("access_token");
    if (removeToken == null) {
      this.router.navigate(["login"]);
    }
  }

  // Error
  handleError(error: HttpErrorResponse) {
    let msg = "";
    if (error.error instanceof ErrorEvent) {
      // client-side error
      msg = error.error.message;
    } else {
      // server-side error
      msg = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(msg);
  }
  verifyToken(token: string): Observable<any> {
    return this.http.post(`${this.endpoint}/verify-token`, { token: token });
  }
}
